import React, { useMemo, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import docsIndex from '../../docs/admin/index.json';
import './DocumentationLibrary.css';

const rawDocModules = import.meta.glob('../../docs/admin/*.md', {
  query: '?raw',
  import: 'default',
  eager: true
});

const docsWithContent = docsIndex
  .map((doc) => {
    const modulePath = `../../docs/admin/${doc.file}`;
    return {
      id: doc.id,
      title: doc.title,
      content: rawDocModules[modulePath] || ''
    };
  })
  .filter((doc) => doc.content);

const DocumentationLibrary = () => {
  const [selectedDocId, setSelectedDocId] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  const filteredDocs = useMemo(() => {
    if (!searchTerm.trim()) {
      return docsWithContent;
    }

    const normalizedSearchTerm = searchTerm.toLowerCase();
    return docsWithContent.filter(
      (doc) =>
        doc.title.toLowerCase().includes(normalizedSearchTerm) ||
        doc.content.toLowerCase().includes(normalizedSearchTerm)
    );
  }, [searchTerm]);

  const selectedDoc =
    filteredDocs.find((doc) => doc.id === selectedDocId) ||
    docsWithContent.find((doc) => doc.id === selectedDocId) ||
    null;

  return (
    <div className="documentation-library">
      <div className="doc-header">
        <h2>📚 Documentation Library</h2>
        <div className="search-container">
          <input
            type="text"
            placeholder="Search documentation..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
        </div>
      </div>

      <div className="doc-content">
        <div className="doc-sidebar">
          <h3>Available Documents</h3>
          <div className="doc-list">
            {filteredDocs.map((doc) => (
              <div
                key={doc.id}
                className={`doc-item ${selectedDoc?.id === doc.id ? 'active' : ''}`}
                onClick={() => setSelectedDocId(doc.id)}
              >
                <h4>{doc.title}</h4>
                <p>{doc.content.substring(0, 100)}...</p>
              </div>
            ))}
          </div>
        </div>

        <div className="doc-viewer">
          {selectedDoc ? (
            <div className="doc-display">
              <h1>{selectedDoc.title}</h1>
              <div className="markdown-content">
                <ReactMarkdown>{selectedDoc.content}</ReactMarkdown>
              </div>
            </div>
          ) : (
            <div className="doc-placeholder">
              <h3>Select a document to view</h3>
              <p>Choose from the list on the left to read the documentation.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DocumentationLibrary;
